import { ApiError } from '../../api/client';
import { errorMessage } from '../../lib/notify';

/** Admin passwords: 12–128 characters (M19 contract). */
export const PASSWORD_MIN = 12;
export const PASSWORD_MAX = 128;

/** Errors of the signed-in account endpoints (/me/password, /me/mfa/*) → readable text. */
export function accountErrorMessage(e: unknown): string {
  if (e instanceof ApiError) {
    switch (e.code) {
      case 'INVALID_MFA_CODE':
        return 'That code is not correct. Check the time on your phone and enter the newest code.';
      case 'INVALID_CURRENT_PASSWORD':
        return 'Your current password is not correct.';
      case 'MFA_SETUP_REQUIRED':
        return 'The setup expired. Start again to get a new QR code.';
      case 'MFA_ALREADY_ENABLED':
        return 'Two-step verification is already on for this account.';
      case 'MFA_NOT_ENABLED':
        return 'Two-step verification is already off.';
      default:
        if (e.status === 429) return 'Too many attempts. Wait a minute and try again.';
    }
  }
  return errorMessage(e);
}

/** Groups a base32 secret for reading aloud / typing: `JBSW Y3DP EHPK 3PXP`. */
export function groupSecret(secret: string): string {
  return secret
    .replace(/\s+/g, '')
    .replace(/(.{4})/g, '$1 ')
    .trim();
}

/** Strength hint 0–4 from length and character variety (guidance only; the API checks length). */
export function passwordStrength(pw: string): number {
  if (!pw) return 0;
  const kinds = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((r) => r.test(pw)).length;
  let score = pw.length >= PASSWORD_MIN ? 1 : 0;
  if (pw.length >= 16) score++;
  if (kinds >= 3) score++;
  if (kinds === 4 && pw.length >= PASSWORD_MIN) score++;
  return Math.min(4, score);
}
